import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreTimelineUserChangesGetAsyncSlice } from './get';

export const coreTimelineUserChangesReducers = combineReducers({
	get: coreTimelineUserChangesGetAsyncSlice.asyncReducers
});

export const coreTimelineUserChangesWatchers = combineAllWatchers([
	coreTimelineUserChangesGetAsyncSlice.asyncWatchers
]);
